export const Data = [
  {
    name: "Rishabh Rathi",
    total: 124,
    subject: "overall",
    leetcode: {
      series: [9, 11, 13],
      total_series: [37, 40, 43],
      labels: ["Hard", "Medium", "Easy"],
      total: [33, 120],
    },
    stackgraph: {
      series: [
        [24, -6],
        [14, -6],
        [5, -5],
        [8, -7],
        [11, -4],
        [6, -4],
        [12, -8],
      ],
      labels: [
        "general aptitude".split(" "),
        "dbms",
        "dsa",
        "os",
        "cn",
        "oops",
        "language",
      ],
    },
    linegraph: {
      series: [1, 2, 1, 2.5, 2, 2.5, 2, 2, 2],
      labels: [
        "Computer Networks",
        "Operating Systems",
        "Database Management System",
        "Project",
        "Aptitude",
        "Programming Language",
        "Competitive Programming",
        "Algorithms",
        "Data Structures",
      ],
    },
    piechart: {
      series: [1, 2, 1, 2.5, 2, 2.5, 2, 2, 2],
      labels: [
        "Computer Networks",
        "Operating Systems",
        "Database Management System",
        "Project",
        "Aptitude",
        "Programming Language",
        "Competitive Programming",
        "Algorithms",
        "Data Structures",
      ],
    },
    comparisonchart: {
      labels: [
        "general aptitude".split(" "),
        "dbms",
        "dsa",
        "os",
        "cn",
        "oops",
        "language",
      ],
      series: [
        [1, 3, 2],
        [5, 1, 0],
        [1, 4, 0],
        [3, 0, 2],
        [7, 1, 3],
        [1, 0, 1],
        [1, 3, 2],
      ],
    },
  },
];

export default Data;
